import { z } from 'zod';
import { DisplayReferenceSchema, UUIDSchema } from '../domain/models';
import { PaginationSchema } from '../domain/pagination';
import { PaginatedBundleSchema } from '../domain/schema';

const Status = [
  'proposed',
  'pending',
  'booked',
  'arrived',
  'fulfilled',
  'cancelled',
  'noshow',
  'entered-in-error',
  'checked-in',
  'waitlist',
] as const;

export const AppointmentSchema = z.object({
  appointmentType: z.string(),
  description: z.string(),
  date: z.string(),
  status: z.enum(Status),
  subject: DisplayReferenceSchema,
});

export const AppointmentGetAllRequestSchema = PaginationSchema.extend({
  patientId: UUIDSchema,
});

export const AppointmentGetAllResponseSchema = PaginatedBundleSchema.extend({
  appointments: z.array(AppointmentSchema),
});

export type Appointment = z.infer<typeof AppointmentSchema>;
export type AppointmentGetAllRequest = z.infer<
  typeof AppointmentGetAllRequestSchema
>;
export type AppointmentGetAllResponse = z.infer<
  typeof AppointmentGetAllResponseSchema
>;
